import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { store } from '../store';
import { showLoading, hideLoading, showErrorPopup } from '../actions';
import { checkActiveSubscriptionPause } from '@utils';

function* loginFacebok(action) {
  let response = null;
  store.dispatch(showLoading());
  const showGeneralPopup = false;
  try {
    response = yield call(
      requestAPI,
      API.API_LOGIN,
      API.POST,
      action.params,
      showGeneralPopup
    );
    if (
      response.status === ResponseStatus.SUCCESS ||
      response.status === ResponseStatus.INCOMPLETE_PROFILE_USER ||
      response.status === ResponseStatus.PROFILE_AWAITING_USER
    ) {
      if (response.data.data.userAuth.user.is_banned) {
        const action = {
          title: 'サービスはご利用いただけません。',
          message: ['詳細につきましては運営までお問い合わせください。'],
          isSubscriptionPause: true
        };
        yield store.dispatch(showErrorPopup(action));
        yield call(requestAPI, API.API_LOGOUT, API.GET, action.params);
      } else {
        yield put({
          type: types.CURRENT_USER_LOGIN_FACEBOOK_SUCCEEDED,
          data: response.data
        });
      }
    } else if (
      response.status === ResponseStatus.FAILURE ||
      response.status === ResponseStatus.DUPLICATE_USER
    ) {
      yield put({
        type: types.CURRENT_USER_LOGIN_FACEBOOK_FAILED,
        error: response
      });
    } else if (
      !!response.data.errors &&
      response.data.errors.type === 'active_subscription_pause'
    ) {
      const action = {
        title: 'お客様のアカウントは\n一時休止中です。',
        isSubscriptionPause: true
      };
      yield store.dispatch(showErrorPopup(action));
    } else if (response.status === ResponseStatus.DUPLICATE_USER_LINE_LOGIN) {
      yield put({
        type: types.CURRENT_USER_LOGIN_FACEBOOK_FAILED,
        error: response.data
      });
    } else {
      yield put({
        type: types.CURRENT_USER_LOGIN_FACEBOOK_FAILED,
        error: response
      });
    }

    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.CURRENT_USER_LOGIN_FACEBOOK_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* forceLoginByAdmin(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_ADMIN_FORCE_LOGIN,
      API.POST,
      action.params
    );
    if (
      [
        ResponseStatus.SUCCESS,
        ResponseStatus.INCOMPLETE_PROFILE_USER,
        ResponseStatus.PROFILE_AWAITING_USER
      ].includes(response.status)
    ) {
      yield put({
        type: types.ADMIN_FORCE_LOGIN_SUCCEEDED,
        data: response.data
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({
        type: types.ADMIN_FORCE_LOGIN_FAILED,
        error: response
      });
    } else {
      yield put({
        type: types.ADMIN_FORCE_LOGIN_FAILED,
        error: response
      });
    }

    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.ADMIN_FORCE_LOGIN_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* forceLoginByUser(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_USER_FORCE_LOGIN,
      API.POST,
      action.params
    );
    if (
      [
        ResponseStatus.SUCCESS,
        ResponseStatus.INCOMPLETE_PROFILE_USER,
        ResponseStatus.PROFILE_AWAITING_USER
      ].includes(response.status)
    ) {
      yield put({
        type: types.USER_FORCE_LOGIN_SUCCEEDED,
        data: response.data
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({
        type: types.USER_FORCE_LOGIN_FAILED,
        error: response
      });
    } else {
      yield put({
        type: types.USER_FORCE_LOGIN_FAILED,
        error: response
      });
    }

    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.USER_FORCE_LOGIN_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* reActivateReApprove(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_REACTIVATE_RE_APPROVE,
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.REACTIVATION_RE_APPROVE_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.REACTIVATION_RE_APPROVE_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.REACTIVATION_RE_APPROVE_FAILED, error });
  }
  store.dispatch(hideLoading());
}
function* reRegister(action) {
  let response = null;
  store.dispatch(showLoading());
  const showGeneralPopup = false;
  try {
    response = yield call(
      requestAPI,
      API.API_REREGISTER,
      API.POST,
      action.params,
      showGeneralPopup
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.RE_REGISTER_SUCCEEDED,
        data: response.data
      });
    } else {
      if (checkActiveSubscriptionPause(response)) {
        return;
      }
      yield put({
        type: types.RE_REGISTER_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.RE_REGISTER_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchLoginFacebook() {
  yield takeLatest(types.CURRENT_USER_LOGIN_FACEBOOK_REQUESTED, loginFacebok);
}

export function* watchForceLoginByAdmin() {
  yield takeLatest(types.ADMIN_FORCE_LOGIN_REQUESTED, forceLoginByAdmin);
}

export function* watchForceLoginByUser() {
  yield takeLatest(types.USER_FORCE_LOGIN_REQUESTED, forceLoginByUser);
}

export function* watchReActivationReApprove() {
  yield takeLatest(types.REACTIVATION_RE_APPROVE_REQUEST, reActivateReApprove);
}
export function* watchReRegister() {
  yield takeLatest(types.RE_REGISTER_REQUEST, reRegister);
}

function* getFacebook(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      'https://graph.facebook.com/v2.5/me?fields=email,name,first_name,last_name,gender',
      API.GET,
      action.params
    );

    yield put({
      type: types.CURRENT_USER_LOGIN_FACEBOOK_INFO_SUCCEEDED
    });

    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.CURRENT_USER_LOGIN_FACEBOOK_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchGetFacebook() {
  yield takeLatest(
    types.CURRENT_USER_LOGIN_FACEBOOK_INFO_REQUESTED,
    getFacebook
  );
}

// XXX: For testing purposes only
function* logoutFacebook(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(requestAPI, API.API_LOGOUT, API.GET, action.params);

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.CURRENT_USER_LOGOUT_FACEBOOK_SUCCEEDED,
        data: response.data
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({
        type: types.CURRENT_USER_LOGOUT_FACEBOOK_FAILED,
        error: response
      });
    } else {
      yield put({
        type: types.CURRENT_USER_LOGOUT_FACEBOOK_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.CURRENT_USER_LOGOUT_FACEBOOK_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchLogoutFacebook() {
  yield takeLatest(
    types.CURRENT_USER_LOGOUT_FACEBOOK_REQUESTED,
    logoutFacebook
  );
}

//SMS login

function* smsSendCode(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_SMS_SEND_CODE,
      API.POST,
      action.params,
      false
    );

    if (
      response.status === ResponseStatus.SUCCESS ||
      response.status === ResponseStatus.INCOMPLETE_PROFILE_USER ||
      response.status === ResponseStatus.PROFILE_AWAITING_USER
    ) {
      yield put({
        type: types.SMS_LOGIN_SEND_CODE_SUCCEEDED,
        data: response.data
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({
        type: types.SMS_LOGIN_SEND_CODE_FAILED,
        error: response
      });
    } else {
      yield put({
        type: types.SMS_LOGIN_SEND_CODE_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.SMS_LOGIN_SEND_CODE_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* smsSocialAuthVerifyPhone(action) {
  let response = null;
  store.dispatch(showLoading());
  const showGeneralPopup = false;
  try {
    response = yield call(
      requestAPI,
      API.API_SOCIAL_AUTH_VERIFY_PHONE,
      API.POST,
      action.params,
      showGeneralPopup
    );

    if (
      response.status === ResponseStatus.SUCCESS ||
      response.status === ResponseStatus.INCOMPLETE_PROFILE_USER ||
      response.status === ResponseStatus.PROFILE_AWAITING_USER
    ) {
      yield put({
        type: types.SMS_SOCIAL_AUTH_SUCCEEDED,
        data: response.data
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({
        type: types.SMS_SOCIAL_AUTH_FAILED,
        error: response
      });
    } else {
      yield put({
        type: types.SMS_SOCIAL_AUTH_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.SMS_SOCIAL_AUTH_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchSMSSocialAuth() {
  yield takeLatest(types.SMS_SOCIAL_AUTH_REQUESTED, smsSocialAuthVerifyPhone);
}

export function* watchSMSSendCode() {
  yield takeLatest(types.SMS_LOGIN_SEND_CODE_REQUESTED, smsSendCode);
}

function* smsVerificationCode(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_SMS_VERIFICATION_CODE,
      API.POST,
      action.params
    );

    if (
      response.status === ResponseStatus.SUCCESS ||
      response.status === ResponseStatus.INCOMPLETE_PROFILE_USER ||
      response.status === ResponseStatus.PROFILE_AWAITING_USER
    ) {
      if (response.data.data.userAuth.user.is_banned) {
        const action = {
          title: 'サービスはご利用いただけません。',
          message: ['詳細につきましては運営までお問い合わせください。'],
          isSubscriptionPause: true
        };
        yield store.dispatch(showErrorPopup(action));
        yield call(requestAPI, API.API_LOGOUT, API.GET, action.params);
      } else {
        yield put({
          type: types.SMS_LOGIN_VERIFICATION_CODE_SUCCEEDED,
          data: {
            ...response.data
          }
        });
      }
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({
        type: types.SMS_LOGIN_VERIFICATION_CODE_FAILED,
        error: response
      });
    } else {
      yield put({
        type: types.SMS_LOGIN_VERIFICATION_CODE_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.SMS_LOGIN_VERIFICATION_CODE_FAILED, error });
  }
}

function* smsSocialAuthVerificationCode(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_SOCIAL_AUTH_VERIFY_PHONE_CODE,
      API.POST,
      action.params
    );

    if (
      response.status === ResponseStatus.SUCCESS ||
      response.status === ResponseStatus.INCOMPLETE_PROFILE_USER ||
      response.status === ResponseStatus.PROFILE_AWAITING_USER
    ) {
      yield put({
        type: types.SMS_SOCIAL_AUTH_VERIFY_CODE_SUCCEEDED
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({
        type: types.SMS_SOCIAL_AUTH_VERIFY_CODE_FAILED,
        error: response
      });
    } else {
      yield put({
        type: types.SMS_SOCIAL_AUTH_VERIFY_CODE_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
    store.dispatch(hideLoading());
  } catch (error) {
    yield put({
      type: types.SMS_SOCIAL_AUTH_VERIFY_CODE_FAILED,
      error
    });
  }
}

export function* watchSocialAuthSmsVerificationCode() {
  yield takeLatest(
    types.SMS_SOCIAL_AUTH_VERIFY_CODE_REQUESTED,
    smsSocialAuthVerificationCode
  );
}

export function* watchSmsVerificationCode() {
  yield takeLatest(
    types.SMS_LOGIN_VERIFICATION_CODE_REQUESTED,
    smsVerificationCode
  );
}
